"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var Stack_1 = require("@nerdwallet/currency/components/Stack");
var Text_1 = require("@nerdwallet/currency/components/Text");
var pointer_1 = __importStar(require("./pointer"));
var sparkle_1 = __importDefault(require("./sparkle"));
var rewards_tracker_module_css_1 = __importDefault(require("./rewards-tracker.module.css"));
var MAX_POINTS = 2500;
var NUM_INTERVALS = 6;
var RewardsTracker = function (_a) {
    var _b, _c;
    var _d = _a.points, points = _d === void 0 ? 0 : _d;
    var percentage = (Math.min(points, MAX_POINTS) / MAX_POINTS) * 100;
    return (react_1.default.createElement(Stack_1.Stack, { spacing: "1" },
        react_1.default.createElement(Box_1.Box, { className: (0, classnames_1.default)((_b = {},
                _b[rewards_tracker_module_css_1.default.invisible] = points >= MAX_POINTS,
                _b)), style: { marginLeft: "calc(".concat(percentage, "% - ").concat(pointer_1.WIDTH / 2, "px)") } },
            react_1.default.createElement(pointer_1.default, null)),
        react_1.default.createElement(Box_1.Box, { backgroundColor: "neutral-lightest", borderRadius: "2", className: rewards_tracker_module_css_1.default.barBase, position: "relative", width: "100" },
            react_1.default.createElement(Box_1.Box, { borderRadius: "2", className: rewards_tracker_module_css_1.default.barProgress, height: "100", style: { width: "".concat(percentage, "%") } }),
            react_1.default.createElement(Box_1.Box, { className: rewards_tracker_module_css_1.default.intervalMarkerContainer, display: "flex", justifyContent: "space-between", position: "absolute", width: "100" }, __spreadArray([], Array(NUM_INTERVALS), true).map(function (_, i) {
                var _a;
                return (react_1.default.createElement(Box_1.Box, { className: (0, classnames_1.default)(rewards_tracker_module_css_1.default.intervalMarker, (_a = {},
                        _a[rewards_tracker_module_css_1.default.invisible] = i === 0,
                        _a[rewards_tracker_module_css_1.default.intervalMarkerEmpty] = points < (MAX_POINTS / (NUM_INTERVALS - 1)) * i,
                        _a[rewards_tracker_module_css_1.default.intervalMarkerFilled] = points >= (MAX_POINTS / (NUM_INTERVALS - 1)) * i,
                        _a)), key: i }));
            })),
            react_1.default.createElement(Box_1.Box, { className: (0, classnames_1.default)(rewards_tracker_module_css_1.default.sparkle, (_c = {},
                    _c[rewards_tracker_module_css_1.default.invisible] = points < MAX_POINTS,
                    _c)), position: "absolute" },
                react_1.default.createElement(sparkle_1.default, null))),
        react_1.default.createElement(Box_1.Box, { display: "flex", justifyContent: "space-between", width: "100" }, __spreadArray([], Array(NUM_INTERVALS), true).map(function (_, i) {
            var _a;
            return (react_1.default.createElement(Box_1.Box, { className: (0, classnames_1.default)((_a = {},
                    _a[rewards_tracker_module_css_1.default.invisible] = i === 0,
                    _a)), key: i },
                react_1.default.createElement(Text_1.Text, { bold: true, size: "small" }, "".concat((((MAX_POINTS / (NUM_INTERVALS - 1)) * i) /
                    1000).toFixed(1), "K"))));
        }))));
};
exports.default = RewardsTracker;
